<script setup>
import Selected from '~/components/Icons/Selected.vue';

const userStore = useUserStore()
const {$_, $formatNumber, $formatStreetAddress, $formatCurrency, $prefixImageUrl, $prefixImageUrlObec} = useNuxtApp()
const isActiveSubject = (subject) => {
  return subject === userStore.activeSubject.value
}

const subjects = computed(() => userStore.subjects)
const activeSubject = computed(() => userStore.activeSubject)
const sortedSubjects = computed(() => {
  if (!userStore.activeSubject) return subjects.value
  return [activeSubject.value, ...subjects.value.filter(subject => subject !== activeSubject.value)];
});
const emits = defineEmits(['close'])

function selectCollectionPoint(subject) {
  userStore.activeSubject.value = subject
  emits('close')
}
</script>

<template>
  <h3 class="text-gray-800">{{ $_('popup_collection_points.title', 'Sběrná místa') }}</h3>
  <div class="wholeWrap">
    <ul>
      <li v-for="subject in sortedSubjects">
        <button @click="() => selectCollectionPoint(subject)">
          <img :src="$prefixImageUrlObec(subject?.municipalityLogoUrl)" v-if="subject?.municipalityLogoUrl" alt=""/>
          <img v-else src="~/assets/img/dashboard/savings.svg" alt="">
          <ul class="details">
            <li>
              <p class="important">{{ subject?.name }}</p>
            </li>
            <li>
              <p>{{ $_('popup_collection_points.collection_point.address', 'Adresa') }}: {{
                  $formatStreetAddress(subject?.address)
                }}
              </p>
            </li>
            <li>
              <p>{{ $_('popup_collection_points.collection_point.yearly_fee', 'Roční poplatek') }}: <span
                class="important">{{
                  $formatCurrency(subject?.fee)
                }}</span></p>
            </li>
            <li class="unpaid" v-if="subject.hasUnpaidInvoices">
              <AlertIconDanger/>
              {{ $_('popup_collection_points.collection_point.unpaid_invoices', 'Nezaplacené faktury') }}
            </li>

          </ul>
          <Selected v-if="isActiveSubject(subject)" class="selectedIcon"></Selected>
        </button>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.unpaid {
  color: #D14A4A;
  background-color: #FFE4E4;
  padding: 6px 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.unpaid svg {
  width: 15px;
}

:global(#popUp) {
  width: 100%;
  max-width: 600px;
}

.selectedIcon {
  position: absolute;
  top: 12px;
  right: 12px;
  opacity: 1;
  transition: opacity 0.3s;
}

h3 {
  font-size: 1.25rem;
  font-weight: 800;
}

img {
  max-width: 64px;
  max-height: 64px;
}

.wholeWrap {
  margin: 24px 0;
}

.wholeWrap > ul {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 8px;
}

.wholeWrap p {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(128 130 133 / var(--tw-text-opacity))
  /* #808285 */;
}

.wholeWrap .important {
  font-size: 1rem;
  font-weight: 700;
  color: #000;
}

.wholeWrap > ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.wholeWrap > ul > li > * {
  background-color: #F9F9F9;
  border: 2px solid #F2F3F3;
  padding: 16px 32px;
  display: flex;
  gap: 32px;
  border-radius: 8px;
  transition: all 0.3s;
  position: relative;
  width: 100%;
  height: 100%;
}

.wholeWrap > ul > li > *:hover {
  background-color: #F3F7D9;
  border: 2px solid #569709;
}
</style>
